import React from 'react';
import './Footer.scss';

const currentYear = new Date().getFullYear();

const Footer = () => {
    return(
    <div  className='footer'>
        <p className='copyright'>&copy; {currentYear} <span className="medium">LeanWisdom</span></p>        
        <div className="brand-logo">
        <span className="text-logo">Maintained by</span>        
        <a className="plexcel-logo" href="https://www.plexcel.com/" target="_blank">
        <img src='./assets/images/png/plexcellogo.png' />
        </a>
            {/* <div className="plexcel-name">" UX . UI by PLEXCEL "</div> */}
        </div>
    </div>
    );
}
export default Footer;


// WEBPACK FOOTER //
// ./common/Footer/Footer.js